import React from 'react';
import s from './index.module.scss';
import { CloseXS } from 'app/shared/assets';
export const MobileMenuModal = ({ children, open, onCancel, className }) => {
    return (
        open && (
            <div className={s.mobile_modal_mask}>
                <div className={`${s.mobile_modal_wrap} ${className}`}>
                    <div className={s.modal_content}>
                        <button className={s.close} onClick={onCancel}>
                            <CloseXS />
                        </button>
                        <div className={s.modal_body}>{children}</div>
                    </div>
                </div>
            </div>
        )
    );
};
